import { useEventCallback } from '@shared/utils/hooks/useEventCallback';
import { previewMessageBusSubject } from '@shared/utils/previewMessageBus';
import { useWebsiteEditorContext } from '../context/WebsiteEditorContext/WebsiteEditor.context';
import { UpdateEventPlaceCacheArgs } from '@shared/utils/eventPlace';

export function useUpdateWebsitePreview() {
  const { pageSlug, eventPageType, pageConfig } = useWebsiteEditorContext();

  const updateWebsitePreview = useEventCallback((updateEventPlaceCache?: UpdateEventPlaceCacheArgs) => {
    previewMessageBusSubject.next({
      type: 'sendMessage',
      payload: {
        message: {
          action: 'adminEventPageChange',
          source: 'joy',
          value: pageConfig?.isPageBlocked && pageSlug ? pageSlug : eventPageType,
          updateEventPlaceCache,
        },
      },
    });
  });

  return { updateWebsitePreview };
}
